import { lazy } from 'react';

const LoginPage = lazy(() => import('features/auth/pages/Login'));
const RegistrationPage = lazy(() => import('features/auth/pages/Register'));
const SetPasswordPage = lazy(() => import('features/auth/pages/SetPassword'));

export const LOGIN_ROUTE = "/login";
export const REGISTRATION_ROUTE = "/register";
export const SET_PASSWORD_ROUTE = "/set-password";

export const authRoutes = [
    { path: LOGIN_ROUTE, element: <LoginPage /> },
    { path: REGISTRATION_ROUTE, element: <RegistrationPage /> },
    { path: SET_PASSWORD_ROUTE, element: <SetPasswordPage /> }
];
